import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BookingDTO, SimpleBookingDTO, SimpleHourBookingDTO } from '@lkp/parking-sdk';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-driver-bookings-list',
  templateUrl: './driver-bookings-list.component.html',
  styleUrls: ['./driver-bookings-list.component.scss'],
  standalone: false
})
export class DriverBookingsListComponent {
  @Input() bookings!: (BookingDTO | SimpleBookingDTO | SimpleHourBookingDTO)[];
  @Input() topic: 'arrival' | 'departure' = 'arrival';

  readonly onDestroy$ = new Subject<void>();

  constructor(private router: Router) {}

  showBooking(row: any) {
    this.router.navigate(['bokning', row.bookingId]);
  }

  wantsChildSafetySeat(element: any): boolean {
    return !!(element?.childSafetySeat || element?.boosterSeat);
  }

  hasDemand(element: any): boolean {
    return (element?.amountToPay ?? 0) > 0;
  }

  carryOnOnly(element: any): boolean {
    return !!element?.handLuggageOnly;
  }

  hasComment(element: any): boolean {
    return !!element?.comment;
  }

  isMissingReturnFlightNumber(element: any): boolean {
    return ![
      element?.arrivalFlight?.flightNumber,
      element?.arrivalFlightNumber,
    ].some((flightNumber) =>
      typeof flightNumber === 'string' && flightNumber.trim().length > 0
    );
  }

  requiresKey(element: any): boolean {
    return (
      element?.resource?.name === 'PARKING_GARAGE' ||
      !!element?.carWash ||
      !!element?.tireRepair
    );
  }

  stop(event: Event) {
    event.stopPropagation();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
